// start case text
export const startCase = (title: string):string => {
    return title.toLowerCase().split(' ').map((word) => {
        return word.charAt(0).toUpperCase() + word.slice(1);
    }).join(' ');
}